module.exports = __webpack_public_path__ + "img/1.f4a1f6a6.jpg";